import '../paedml-modal.tag'
import '../paedml-form-input.tag'
import '../components/paedml-date-picker.tag'

<paedml-modal-mdm-log>
  <paedml-modal prefix={opts.prefix} 
      heading={opts.heading} opname={opts.opname} edit={opts.edit} 
      selectedrowsfunc={opts.selectedrowsfunc} idcol={opts.idcol} idtextcol={opts.idtextcol}
      submitfunc={submitHandler}>
  
    <yield to="fields">
      <div class="paedml-input-group">
        <div class="pb-1">
          Log-Einträge
        </div>
        <div class="row">
          <div class="col-md-3">
              <paedml-form-input name="logInfo" placeholder="INFO" fgclass="py-1"
                type="checkbox" revlut="jaNein"
              />
          </div>
          <div class="col-md-3">
              <paedml-form-input name="logWarn" placeholder="WARN" fgclass="py-1"
                type="checkbox" revlut="jaNein"
              />
          </div>
          <div class="col-md-6">
              <paedml-form-input name="logError" placeholder="ERROR (immer aktiv)" fgclass="py-1"
                type="checkbox" revlut="jaNein" readonly={true}
              />
          </div>
        </div>
      </div>
      <div class="paedml-input-group">
        <div class="pb-1">
          Einen Zeitraum für die Log-Datei auswählen:
        </div>
        <div class="row">
         <div class="col-md-12">
          <paedml-form-input name="logInterval"
            type="select" values={parent.session.map.mdmLogs} revlut="mdmLogs"
            required data-msg="Bitte wählen Sie einen Zeitraum aus"
          />
          </div>
        </div>
      </div>
      <div class="paedml-input-group">
        <div class="row">
            <div class="col-md-12">
              <div class="mt-2 mr-1 p-2 border border-info">
                <paedml-icon icon="fas-info-circle" simple="info" />
                <span class="text-info pl-1 pt-2">Download der Log-Datei kann einige Minuten dauern.</span>
                <span class="text-info pl-1 pt-2">Die Log-Datei wird im Ordner <strong class="text-info pl-1 pt-2">\\Sp01\pgm$\PGM_Admins\MDM_Logs</strong> hinterlegt.</span>
                </div>
            <div class="p-2"></div>
            </div>
        </div>
        <div class="row">
          <div class="m-2 p-2">
            <span class="pl-1 pt-2">Es werden Jobs erstellt, um die MDM Log-Datei herunterzuladen.</span>
            <p></p>
            <paedml-form-input name="redirect" placeholder="Nach der Ausführung zur 'JobQueue'-Ansicht springen" fgclass="py-1"
              type="checkbox" revlut="jaNein"
              />
          </div>
        </div>
      </div>
    </yield>
  </paedml-modal>
    
    <script>
      import { handleSubmitCreateOrEdit } from '../../util/api-util'
      import API from '../../api'
      import Session from '../../store/session'
      
      this.opname = this.opts.opname
      this.data = {}
      this.edit = true
      this.session = Session

      this.on('dataRequested', () => {
        this.data.logInfo = true
        this.data.logWarn = true
        this.data.logError = true
      })

      this.submitHandler = formData => {
        return API.mdm.log(formData).then(rsp => {
          const [data, status] = rsp
          if (status.error) return Promise.reject('Kommunikationsfehler mit dem Server')

          if(status.success) {
            
            if (this.data.redirect)  setTimeout(() => { 
              $('body').removeClass('modal-open')
              window.location.href = '/#jobverwaltung/jobs' 
            }, 500)

            this.parent.trigger('reloadTable')

            return 'Download der MDM Log-Datei wurde erfolgreich gestartet.'
          }
        })
    }
    </script>
</paedml-modal-mdm-log>
